@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}
<div style="padding: 15px;">
    @for (todo of TodosList; track todo) {
    <mat-card (click)="navigateToObjectService(todo)">
        <mat-card-header>
            <mat-card-title>
                <span>{{todo.Objektbezeichnung }}</span>
                @if(this.getObjektistErledigt(todo)){<mat-icon >check</mat-icon>}
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <table>
                <tr>
                    <td>{{language.Termin | translationPipe}}</td>
                    <td>{{todo.Termin | date:"dd.MM.yyyy"}}</td>
                </tr>
            </table>
        </mat-card-content>
    </mat-card>
    }
</div>